<div
  [ngClass]="{ visible: isVisible }"
  [ngStyle]="{ 'left.px': isVisible ? x : 0, 'top.px': isVisible ? y : 0 }"
  class="context-menu-wrapper"
>
  <ng-content></ng-content>
</div>
